// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"GroupPhotos_sliderContainer__226tn","groupPhotoItem":"GroupPhotos_groupPhotoItem__V21xP"};